export default "__VITE_ASSET__DcXLWZh3__"